<template>
  <v-col class="pa-0">
    <v-textarea
      ref="textarea"
      v-model="modifiedCommentText"
      class="mb-2"
      :class="{ 'unfocused-comment-input': !editFocused }"
      outlined
      auto-grow
      hide-details="auto"
      background-color="white"
      :placeholder="placeholder"
      :disabled="saving"
      :counter="maxLength"
      :rules="commentTextRules"
      @blur="editFocused = false"
      @focus="editFocused = true"
    />
    <v-row class="mx-0 my-0 py-0">
      <v-btn
        small
        color="primary"
        class="mr-2"
        :loading="saving"
        :disabled="saveDisabled"
        @click="onSave"
      >
        Save
      </v-btn>
      <v-btn small :disabled="saving" @click="onCancel">
        Cancel
      </v-btn>
    </v-row>
  </v-col>
</template>

<script>
const MAX_LENGTH = 1000;

export default {
  name: 'CommentTextarea',
  props: {
    value: {
      type: String,
      default: null,
    },
    saving: {
      type: Boolean,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    clearOnCancel: {
      type: Boolean,
      default: false,
    },
    focusOnNextTick: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      editing: false,
      editFocused: false,
    };
  },
  computed: {
    maxLength() {
      return MAX_LENGTH;
    },
    modifiedCommentText: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    commentEmpty() {
      return this.modifiedCommentText.trim() === '';
    },
    commentTextHasErrors() {
      return this.commentTextRules.length > 0;
    },
    commentTextRules() {
      const errors = [];
      if (this.modifiedCommentText.length > MAX_LENGTH) {
        errors.push(
          `Comments must be no longer than ${MAX_LENGTH} characters.`
        );
      }

      return errors;
    },
    saveDisabled() {
      return this.commentTextHasErrors || this.commentEmpty;
    },
  },
  watch: {
    focusOnNextTick(focusOnNextTick) {
      if (focusOnNextTick) {
        this.$refs.textarea.focus();
        this.$emit('update:focusOnNextTick', false);
      }
    },
  },
  mounted() {
    this.$refs.textarea.focus();
  },
  methods: {
    onCancel() {
      if (this.clearOnCancel) {
        this.modifiedCommentText = '';
      }
      this.$emit('onCancel');
    },
    onSave() {
      this.$emit('onSave', this.modifiedCommentText);
      this.modifiedCommentText = '';
    },
  },
};
</script>
<style scoped>
.unfocused-comment-input >>> fieldset {
  border-color: lightgray;
}
</style>
